export default __webpack_public_path__ + "static/media/nissan-brand-logo.1b8e52a8.jpg";